import React from 'react';
import { BarChart2Icon, TrendingUpIcon, UsersIcon, TargetIcon, BriefcaseIcon, AwardIcon } from 'lucide-react';
export const AboutSection = () => {
  return <section id="about" className="py-16 md:py-24 bg-[#f5f5f5] text-black" data-id="element-17">
      <div className="container mx-auto px-6" data-id="element-18">
        <div className="mb-5" data-id="element-19">
          <span className="text-black font-medium inline-flex items-center gap-2 bg-white/70 px-4 py-1.5 rounded-full shadow-sm" data-id="element-20">
            <div className="w-6 h-6 bg-[#FF7A39] rounded-sm" data-id="element-21"></div>
            About us
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-22">
          <div data-id="element-23">
            <h2 className="text-3xl md:text-5xl font-bold text-black mb-6" data-id="element-24">
              Our{' '}
              <span className="font-serif italic text-[#FF7A39]" data-id="element-25">Mission</span>
            </h2>
            <p className="text-lg text-black/70 mb-6 leading-relaxed" data-id="element-26">
              Our mission is to transform how events and conferences approach
              sponsorship sales. We combine deep industry expertise with
              data-driven methodologies to deliver exceptional results for our
              clients.
            </p>
            <p className="text-lg text-black/70 mb-6 leading-relaxed" data-id="element-27">
              As a specialized Business Process Outsourcing (BPO) partner, we
              handle the entire sponsorship sales cycle, allowing you to focus
              on creating exceptional event experiences while we maximize your
              revenue.
            </p>
            <p className="text-lg text-black/70 leading-relaxed" data-id="element-28">
              Our team brings decades of combined experience in sponsorship
              sales, marketing, and relationship management across diverse
              industries and event types.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-29">
            <div className="bg-white p-5 md:p-7 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-all transform hover:-translate-y-1 duration-300" data-id="element-30">
              <div className="bg-[#FF7A39]/20 p-3 rounded-full w-fit mb-4" data-id="element-31">
                <TrendingUpIcon className="text-black" size={24} data-id="element-32" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-black" data-id="element-33">
                Revenue Focused
              </h3>
              <p className="text-black/70 leading-relaxed" data-id="element-34">
                Our clients typically see 30-45% increase in sponsorship revenue
                within the first event cycle.
              </p>
            </div>
            <div className="bg-white p-5 md:p-7 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-all transform hover:-translate-y-1 duration-300" data-id="element-35">
              <div className="bg-[#FF7A39]/20 p-3 rounded-full w-fit mb-4" data-id="element-36">
                <UsersIcon className="text-black" size={24} data-id="element-37" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-black" data-id="element-38">
                Specialist Team
              </h3>
              <p className="text-black/70 leading-relaxed" data-id="element-39">
                Dedicated sponsorship sales experts with industry-specific
                knowledge and extensive sponsor networks.
              </p>
            </div>
            <div className="bg-white p-5 md:p-7 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-all transform hover:-translate-y-1 duration-300" data-id="element-40">
              <div className="bg-[#FF7A39]/20 p-3 rounded-full w-fit mb-4" data-id="element-41">
                <BriefcaseIcon className="text-black" size={24} data-id="element-42" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-black" data-id="element-43">
                Industry Experience
              </h3>
              <p className="text-black/70 leading-relaxed" data-id="element-44">
                Over 500 successful sponsorship campaigns across technology,
                healthcare, finance, and education sectors.
              </p>
            </div>
            <div className="bg-white p-5 md:p-7 rounded-lg shadow-md border border-gray-100 hover:shadow-lg transition-all transform hover:-translate-y-1 duration-300" data-id="element-45">
              <div className="bg-[#FF7A39]/20 p-3 rounded-full w-fit mb-4" data-id="element-46">
                <AwardIcon className="text-black" size={24} data-id="element-47" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-black" data-id="element-48">
                Proven Results
              </h3>
              <p className="text-black/70 leading-relaxed" data-id="element-49">
                Track record of exceeding targets with transparent reporting and
                accountability at every step.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};